import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { AnimatedIcon } from './HowWeHelp/AnimatedIcon';
import { TimelineConnector } from './HowWeHelp/TimelineConnector';
export function HowWeHelp() {
  const pillars = [{
    number: 1,
    icon: <CheckCircle size={24} className="text-primary" data-id="element-62" />,
    title: 'Unlike marketing agencies',
    description: 'We don\'t charge retainers for "activity." We deliver measurable case flow on pay-per-performance models.'
  }, {
    number: 2,
    icon: <CheckCircle size={24} className="text-primary" data-id="element-63" />,
    title: 'Unlike lead aggregators',
    description: "We don't sell you stale or recycled leads. We generate exclusive, case-ready prospects."
  }, {
    number: 3,
    icon: <CheckCircle size={24} className="text-primary" data-id="element-64" />,
    title: 'Unlike in-house hires',
    description: "We don't require overhead, training, or management. We run campaigns 24/7 and deliver qualified cases directly to your CRM."
  }];
  return <section id="why-us" className="w-full px-6 md:px-12 py-24 bg-cream text-navy overflow-hidden" data-id="element-65">
      <div className="max-w-6xl mx-auto" data-id="element-66">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24" data-id="element-67">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-68">
            <h2 className="font-display text-2xl font-medium mb-4" data-id="element-69">
              Our Differentiation
            </h2>
            <p className="text-lg text-navy/80" data-id="element-70">
              After generating over $100M for our clients, we've perfected a
              system that can repeatably generate qualified prospects for
              service businesses.
            </p>
          </motion.div>
          <div className="relative" data-id="element-71">
            <TimelineConnector data-id="element-72" />
            <div className="space-y-16" data-id="element-73">
              {pillars.map((pillar, index) => <motion.div key={index} className="relative flex gap-8" initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5,
              delay: index * 0.2
            }} data-id="element-74">
                  <div className="relative" data-id="element-75">
                    <AnimatedIcon delay={index * 0.3} data-id="element-76">
                      {pillar.icon}
                    </AnimatedIcon>
                  </div>
                  <div className="bg-white/50 backdrop-blur-sm rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow" data-id="element-77">
                    <h3 className="text-xl font-bold mb-2" data-id="element-78">{pillar.title}</h3>
                    <p className="text-navy/80" data-id="element-79">{pillar.description}</p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}